export default __webpack_public_path__ + "static/media/phone-03.19948101.png";